import { Link } from "react-router-dom";
import { Home, Phone } from "lucide-react";
import Seo from "@/components/Seo";
import { useSite, telLink } from "@/context/SiteContext";

export default function NotFound() {
  const s = useSite();
  return (
    <>
      <Seo title="Page Not Found | Chouhan Taxi Service" description="The page you are looking for could not be found." path="/404" robots="noindex, follow" />
      <section className="min-h-[60vh] flex items-center justify-center py-20">
        <div className="container-x text-center max-w-lg">
          <div className="text-7xl sm:text-8xl font-heading font-extrabold text-brand">404</div>
          <h1 className="mt-4 text-2xl sm:text-3xl font-heading font-bold text-navy-heading">Page Not Found</h1>
          <p className="mt-3 text-slate-600">The page you are looking for doesn't exist or has moved. Let's get you back on the road.</p>
          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <Link to="/" className="inline-flex items-center gap-2 bg-brand text-white font-semibold px-6 py-3 rounded-full hover:bg-royal transition-colors"><Home className="w-4 h-4" /> Back to Home</Link>
            <a href={telLink(s)} className="inline-flex items-center gap-2 border border-slate-300 text-navy font-semibold px-6 py-3 rounded-full"><Phone className="w-4 h-4" /> Call {s.phone}</a>
          </div>
        </div>
      </section>
    </>
  );
}
